import { render, staticRenderFns } from "./FormsHomeSkeleton.vue?vue&type=template&id=12d642ac&scoped=true"
import script from "./FormsHomeSkeleton.vue?vue&type=script&lang=js"
export * from "./FormsHomeSkeleton.vue?vue&type=script&lang=js"
import style0 from "./FormsHomeSkeleton.vue?vue&type=style&index=0&id=12d642ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d642ac",
  null
  
)

export default component.exports